import React from "react";
import Translate from "react-translate-component";
import FormattedAsset from "../../Utility/FormattedAsset";
import TranslateWithLinks from "../../Utility/TranslateWithLinks";
export const WorkerCreate = ({
  op,
  fromComponent
}) => {
  if (fromComponent === "proposed_operation") {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "proposal.create_worker"
    }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
      style: {
        fontWeight: "bold"
      },
      amount: op[1].daily_pay,
      asset: "1.3.0"
    }));
  } else {
    return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(TranslateWithLinks, {
      string: "operation.worker_create",
      keys: [{
        type: "account",
        value: op[1].owner,
        arg: "account"
      }, {
        type: "amount",
        value: {
          amount: op[1].daily_pay,
          asset_id: "1.3.0"
        },
        arg: "pay"
      }],
      params: {
        name: op[1].name
      }
    }));
  }
};